import insuranceCategoryTypes from "@/enums/insuranceCategoryTypes";
import statusQuotationTypes from "@/enums/statusQuotationTypes";
import reasonCancelTypes from "@/enums/reasonCancelTypes";
import { sanitizeDocument, formatCnpj, isValidCnpj } from "@/utils/document";

export default {
  data: () => ({
    insuranceCategoryTypes: insuranceCategoryTypes,
    statusQuotationTypes: statusQuotationTypes,
    reasonCancelTypes: reasonCancelTypes,
  }),
  methods: {
    getEnumKeyByEnumValue(myEnum, enumValue) {
      let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
      return keys.length > 0 ? keys[0] : null;
    },
    openLinkTargetBlank(url) {
      window.open(
        url,
        '_blank'
      );
    },
    allowedJudicial() {
      return [
        this.insuranceCategoryTypes.MAKE_A_LABOR_APPEAL_DEPOSIT,
        this.insuranceCategoryTypes.ENSURE_A_LABOR_EXECUTION,
        this.insuranceCategoryTypes.I_HAVE_TAX_CREDIT_OR_INSTALLMENT,
        this.insuranceCategoryTypes.TAX_ENFORCEMENT,
        this.insuranceCategoryTypes.APPEAL_A_CIVIL_ACTION,
        this.insuranceCategoryTypes.REPLACEMENT_OF_APPEAL_DEPOSIT,
      ]
    },
    allowedCustoms() {
      return [
        this.insuranceCategoryTypes.CUSTOMS,
        this.insuranceCategoryTypes.CUSTOMS_TRANSIT,
        this.insuranceCategoryTypes.CUSTOMS_TEMPORARY_ADMISSION,
        this.insuranceCategoryTypes.ENERGY_PAYMENT,
      ]
    },
    listStatusKanbanQuotation() {
      return [
        this.statusQuotationTypes.ANALYSIS,
        this.statusQuotationTypes.APPROVED,
        this.statusQuotationTypes.ISSUE,
        this.statusQuotationTypes.ISSUED,
        this.statusQuotationTypes.DECLINED,
        this.statusQuotationTypes.ISSUE_FAILURE,
        this.statusQuotationTypes.ACTIVE,
        this.statusQuotationTypes.CANCELED,
        this.statusQuotationTypes.ENDORSED,
      ];
    },
    listStatusKanbanEndorsement() {
      return [
        this.statusQuotationTypes.PROGRESS,
        this.statusQuotationTypes.PENDING,
        this.statusQuotationTypes.RESOLVED,
      ];
    },
    listStatusKanbanPolicyRenewal() {
      return [
        this.statusQuotationTypes.AWAITING_DOCUMENTATION,
        this.statusQuotationTypes.AWAITING_APPROVAL,
        this.statusQuotationTypes.FINISHED,
        this.statusQuotationTypes.CANCELED
      ];
    },
    listReasonCancel() {
      return [
        this.reasonCancelTypes.PROCESS_FINALIZED,
        this.reasonCancelTypes.NO_RETURN,
        this.reasonCancelTypes.RENEWED_WITH_ANOTHER_BROKER,
        this.reasonCancelTypes.OTHERS
      ];
    },
    listStatusQuotationChange() {
      return [
        this.statusQuotationTypes.DRAFT,
        this.statusQuotationTypes.ANALYSIS,
        this.statusQuotationTypes.APPROVED,
        this.statusQuotationTypes.DECLINED,
        this.statusQuotationTypes.ISSUE_FAILURE,
      ];
    },
    economicGroupTypes() {
      return [
        { id: 1, label: 'Coligada' },
        { id: 2, label: 'Filial' },
        { id: 3, label: 'Controlada' },
        { id: 4, label: 'Controladora' },
      ];
    },
    economicGroupTypeLabel(id) {
      const type = this.economicGroupTypes().find(t => t.id === Number(id));
      return type ? type.label : '';
    },
    classStatusQuotation(id) {
      let classStatus
      switch (id) {
        case 1:
        case 10:
        case 11:
          classStatus = 'btn btn-sm btn-outline-secondary text-uppercase rounded-pill nowrap';
          break;
        case 2:
          classStatus = 'btn btn-sm btn-primary text-uppercase rounded-pill nowrap';
          break;
        case 3:
        case 12:
        case 13:
          classStatus = 'btn btn-sm btn-orange text-white text-uppercase rounded-pill nowrap';
          break;
        case 4:
          classStatus = 'btn btn-sm btn-outline-success text-uppercase rounded-pill nowrap';
          break;
        case 5:
        case 8:
        case 14:
          classStatus = 'btn btn-sm btn-success text-uppercase rounded-pill nowrap';
          break;
        case 6:
        case 7:
        case 9:
          classStatus = 'btn btn-sm btn-danger text-uppercase rounded-pill nowrap';
          break;
        // case 10:
        //   classStatus = 'btn btn-sm btn-primary-opmitize text-uppercase rounded-pill nowrap';
        //   break;
        case 15:
        case 18:
          classStatus = 'btn btn-sm btn-orange text-white text-uppercase rounded-pill nowrap';
          break;
        default:
          classStatus = 'btn btn-sm btn-outline-secondary text-uppercase rounded-pill nowrap';
      }
      return classStatus
    },
    traitCnpj(cnpj = '') {
      // CNPJ alfanumérico (Receita Federal): mantém letras e dígitos, em maiúsculo.
      // Para CPF (somente dígitos) o resultado é idêntico ao strip numérico antigo.
      return sanitizeDocument(cnpj);
    },
    formatCnpj(cnpj = '') {
      return formatCnpj(cnpj);
    },
    isValidCnpj(cnpj = '') {
      return isValidCnpj(cnpj);
    },
    getIdFromUrl() {
      const url = window.location.href;
      return url.split("/").slice(-1)[0];
    },
    isUuid(string) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(string);
    },
    truncateText(text, limit = 30) {
      if (!text) return '';
      if (text.length <= limit) return text;

      const trimmed = text.substring(0, limit);
      return trimmed.substring(0, trimmed.lastIndexOf(' ')) + ' ...';
    },
    truncateHtmlText(html, limit = 30) {
      if (!html) return '';
      const text = html.replace(/<[^>]*>?/gm, '')
      return this.truncateText(text, limit);
    }
  }
}
